import React from 'react'
import css from '../ResearchWinesPage.module.css';
import {IoIosArrowDown} from 'react-icons/io'

function FilterByShipToState({
  states,
  selectedState,
  setSelectedState
}) {
  return (
    <div>
      <h3>Ships To</h3>
      <div className={css.seleteWrapper}>
        <select
          className={css.stateSelete}
          name={selectedState}
          id={selectedState}
          value={selectedState}
          onChange={(e) => {
            setSelectedState(e.target.value)
          }}
        >
          <option key="winery" value="" disabled>Filter by Ships To</option>
          {states?.map(st => (
            <option key={st.value} value={st.name}>{st.name}</option>
          ))}
        </select>
        <IoIosArrowDown className={css.selectIcon} />
      </div>
    </div>
  )
}

export default FilterByShipToState